const SafeHtml = ({ html, className = '' }) => (
  <div
    className={className}
    dangerouslySetInnerHTML={{ __html: html || '' }}
  />
);

export default SafeHtml;
